export const CRMExpenses = [
  {
    category: "Consulting",
    amount: "Rs.20,000.00",
    name: "Ikrar Payment",
    receipt: "",
    date: "18/03/2025",
    project: "Microsoft HYD-01",
    customer: "Infosys Ltd",
    invoice: "Ikrar Invoice 18-Mar-2025.pdf",
    reference: "INV-2025-001",
    payment_mode: "NEFT",
    supplier: "Ikrar",
  },
  {
    category: "Travel",
    amount: "Rs.1,850.00",
    name: "Cab charges for client meeting",
    receipt: "Cab Receipt 25-Mar-2025.pdf",
    date: "25/03/2025",
    project: "Microsoft HYD-01",
    customer: "Tata Consultancy Services",
    invoice: "Cab Invoice 25-Mar-2025.pdf",
    reference: "INV-2025-006",
    payment_mode: "UPI",
    supplier: "Ola Cabs",
  },
  {
    category: "Meals",
    amount: "Rs.1,240.00",
    name: "Team lunch during installation",
    receipt: "Lunch Receipt 24-Mar-2025.pdf",
    date: "24/03/2025",
    project: "Microsoft HYD-01",
    customer: "Wipro Ltd",
    invoice: "Lunch Invoice 24-Mar-2025.pdf",
    reference: "INV-2025-007",
    payment_mode: "Card",
    supplier: "Paradise Restaurant",
  },
  {
    category: "Hardware",
    amount: "Rs.8,920.00",
    name: "Network cables and connectors",
    receipt: "Cable Purchase Receipt.pdf",
    date: "22/03/2025",
    project: "Microsoft HYD-01",
    customer: "Tech Mahindra",
    invoice: "Cable Invoice 22-Mar-2025.pdf",
    reference: "INV-2025-008",
    payment_mode: "Bank Transfer",
    supplier: "Tech Cables India",
  },
  {
    category: "Accommodation",
    amount: "Rs.4,500.00",
    name: "Hotel stay for onsite engineer",
    receipt: "Hotel Receipt 21-Mar-2025.pdf",
    date: "21/03/2025",
    project: "Microsoft HYD-01",
    customer: "HCL Technologies",
    invoice: "Hotel Invoice 21-Mar-2025.pdf",
    reference: "INV-2025-009",
    payment_mode: "Card",
    supplier: "Hotel Grand Inn",
  },
  {
    category: "Stationery",
    amount: "Rs.950.00",
    name: "Printer paper and office supplies",
    receipt: "Stationery Receipt.pdf",
    date: "20/03/2025",
    project: "Microsoft HYD-01",
    customer: "Accenture India",
    invoice: "Stationery Invoice 20-Mar-2025.pdf",
    reference: "INV-2025-010",
    payment_mode: "Cash",
    supplier: "Sri Office Needs",
  },
  {
    category: "Internet",
    amount: "Rs.1,499.00",
    name: "Temporary internet connection",
    receipt: "Internet Receipt.pdf",
    date: "19/03/2025",
    project: "Microsoft HYD-01",
    customer: "Capgemini India",
    invoice: "Internet Invoice 19-Mar-2025.pdf",
    reference: "INV-2025-011",
    payment_mode: "UPI",
    supplier: "Airtel Business",
  },
  {
    category: "Electrical",
    amount: "Rs.3,780.00",
    name: "Power extension boards and sockets",
    receipt: "Electrical Receipt.pdf",
    date: "17/03/2025",
    project: "Microsoft HYD-01",
    customer: "Cognizant Technology Solutions",
    invoice: "Electrical Invoice 17-Mar-2025.pdf",
    reference: "INV-2025-012",
    payment_mode: "Bank Transfer",
    supplier: "Power Solutions",
  },
  {
    category: "Consulting",
    amount: "Rs.12,500.00",
    name: "Security audit consultation",
    receipt: "Consultant Receipt.pdf",
    date: "16/03/2025",
    project: "Microsoft HYD-01",
    customer: "LTIMindtree",
    invoice: "Consulting Invoice 16-Mar-2025.pdf",
    reference: "INV-2025-013",
    payment_mode: "NEFT",
    supplier: "SecureTech Consultants",
  },
  {
    category: "Petrol",
    amount: "Rs.1,120.00",
    name: "Fuel for client support visit",
    receipt: "Fuel Receipt 15-Mar-2025.pdf",
    date: "15/03/2025",
    project: "Microsoft HYD-01",
    customer: "Oracle India",
    invoice: "Fuel Invoice 15-Mar-2025.pdf",
    reference: "INV-2025-014",
    payment_mode: "Card",
    supplier: "Indian Oil",
  },
  {
    category: "Software",
    amount: "Rs.6,750.00",
    name: "Remote support software license",
    receipt: "Software License Receipt.pdf",
    date: "14/03/2025",
    project: "Microsoft HYD-01",
    customer: "IBM India",
    invoice: "Software Invoice 14-Mar-2025.pdf",
    reference: "INV-2025-015",
    payment_mode: "Bank Transfer",
    supplier: "Tech Software Solutions",
  },
  {
    category: "Petrol",
    amount: "Rs.2,680.00",
    name: "Fuel for site visit HYD01 Feb22nd - Mar12th",
    receipt: "Fuel for site visit HYD01 22feb - 12mar.pdf",
    date: "12/03/2025",
    project: "Microsoft HYD-01",
    customer: "Amazon Development Centre India",
    invoice: "Fuel Invoice 12-Mar-2025.pdf",
    reference: "INV-2025-002",
    payment_mode: "Card",
    supplier: "Fuel Station",
  },
  {
    category: "Hardware",
    amount: "Rs.380.00",
    name: "Tools for Prudent HYD 01",
    receipt: "Tools from nearby store hyd01.pdf",
    date: "10/03/2025",
    project: "Microsoft HYD-01",
    customer: "Google India",
    invoice: "Tools Invoice 10-Mar-2025.pdf",
    reference: "INV-2025-003",
    payment_mode: "Cash",
    supplier: "Local Hardware Store",
  },
  {
    category: "Hardware",
    amount: "Rs.14,713.00",
    name: "Tools for Prudent HYD 01",
    receipt: "Kunal tools invoice 08-Mar-2025.pdf",
    date: "08/03/2025",
    project: "Microsoft HYD-01",
    customer: "Deloitte India",
    invoice: "Kunal Tools Invoice 08-Mar-2025.pdf",
    reference: "INV-2025-004",
    payment_mode: "Bank Transfer",
    supplier: "SME Safety and Security LLP",
  },
  {
    category: "Petrol",
    amount: "Rs.330.00",
    name: "Fuel for Site Visit Hyd 1",
    receipt: "Petrol hyd -3.pdf",
    date: "07/03/2025",
    project: "Microsoft HYD-01",
    customer: "Adobe India",
    invoice: "Fuel Invoice 07-Mar-2025.pdf",
    reference: "INV-2025-005",
    payment_mode: "UPI",
    supplier: "Fuel Station",
  },
];
